const formDataComplete = (props, errors, setErrors) => {
    let newErrors = {};
    for (let param in errors) {
        newErrors[param] = false;
    }

    let returnError = false;

    if(props.user.surname.value.length < 2) {
        newErrors.surname = true;
        returnError = true;
    }

    if(props.user.name.value.length < 2) {
        newErrors.name = true;
        returnError = true;
    }

    if(!props.user.phone.value) {
        newErrors.phone = true;
        returnError = true;
    }

    if(!props.geo.city.data) {
        newErrors.city = true;
        returnError = true;
    }

    if(!props.geo.street.data) {
        newErrors.street = true;
        returnError = true;
    }

    if(!props.geo.house.data) {
        newErrors.house = true;
        returnError = true;
    }

    setErrors(newErrors);

    return returnError;
};

export default formDataComplete;